var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5382 3.74566L6.97677 8.22815C6.54489 8.98394 5.45511 8.98394 5.02323 8.22815L2.4618 3.74566C2.03324 2.99567 2.57478 2.0625 3.43858 2.0625L8.56142 2.0625C9.42522 2.0625 9.96676 2.99567 9.5382 3.74566Z",
    fill: "#32363E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownChevron);
export default __webpack_public_path__ + "static/media/dropdown-chevron.c9153be3fc1882919ddfd0a016296467.svg";
export { ForwardRef as ReactComponent };